import ArticleCard from '@/components/base/ArticleCard';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = getLatestArticles(6);

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-500 text-sm">持续更新，发现更多亚洲精彩</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <ArticleCard key={article.slug} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}